import React from 'react'
import { MdSchool } from "react-icons/md";
import {
    Box,
    chakra,
    Container,
    Link,
    SimpleGrid,
    Stack,
    Text,
    VisuallyHidden,
    Input,
    IconButton,
    useColorModeValue,
    Avatar,
    Img,
    HStack,
    Center,
    
} from "@chakra-ui/react";
import { Heading } from '@chakra-ui/react'



// function Feature({ title, desc, ...rest 
//   return (
//     <Center>
//     <Stack spacing={8} direction='row' mt='20px' >
//     <Feature
//     title='Plan Money'
//     desc='The future can be even brighter but a goal without a plan is just a wish'
//   />
//   <Feature
//     title='Save Money'
//     desc='You deserve good things. With a whooping 10-15% interest rate per annum, grow your savings on your own terms with our completely automated process'
//   />
// </Stack>
//     </Center>
//   )

function Feature({ title, desc, ...rest }) {
    return (
      <Box p={5} shadow='md' borderWidth='1px' {...rest}>
        <Heading fontSize='50' color='orange'>{title}</Heading>
       
      </Box>
    )
  }
  
  function ContactHeader() {
    return (
        <Center>
      <Stack spacing={8} direction='row' mt='20px'  rounded='xl'>
        <Feature
          title='Contact Us'
         
        />
     
      </Stack>
      
      </Center>
    )
  }
  export default ContactHeader